import { useEffect } from 'react';

// Extend the Window interface to include Tally
declare global {
  interface Window {
    Tally?: {
      loadEmbeds: () => void;
    };
  }
}

export default function TallyFormEmbed() {
  useEffect(() => {
    // Load Tally embed script
    const loadTally = () => {
      if (typeof window.Tally !== 'undefined') {
        window.Tally.loadEmbeds();
      } else {
        document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach((iframe) => {
          const element = iframe as HTMLIFrameElement;
          const tallySrc = element.getAttribute('data-tally-src');
          if (tallySrc) {
            element.src = tallySrc;
          }
        });
      }
    };

    // Check if script already exists
    const existingScript = document.querySelector('script[src="https://tally.so/widgets/embed.js"]');
    
    if (typeof window.Tally !== 'undefined') {
      loadTally();
    } else if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.onload = loadTally;
      script.onerror = loadTally;
      document.body.appendChild(script);
    }

    // Cleanup function
    return () => {
      // Optional: remove script on unmount if needed
    };
  }, []);

  return (
    <div>
    <iframe
      data-tally-src="https://tally.so/embed/D4kbK5?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1"
      loading="lazy"
      width="100%"
      height="180"
      frameBorder="0"
      title="Hey, New York!"
    />

    </div>
  );
}